import { getToken } from '@/utils';
import axios from 'axios';
var globalBaseURL = '';
var tokenKey = '';
var appIdentifier = '';
var customerSecretKey = '';
export var setAppIdentifier = function (identifier) {
    appIdentifier = identifier;
};
export var setCustomerSecretKey = function (secretKey) {
    customerSecretKey = secretKey;
};
export var setBaseURL = function (baseURL) {
    globalBaseURL = baseURL;
};
export var setTokenKey = function (key) {
    tokenKey = key;
};
export var getTokenKey = function () { return tokenKey; };
var axiosInstance = axios.create({
    baseURL: globalBaseURL,
});
axiosInstance.interceptors.request.use(function (config) {
    var _a, _b, _c, _d;
    // Update the baseURL if it has changed
    if (config.baseURL !== globalBaseURL) {
        config.baseURL = globalBaseURL;
    }
    // Add token logic
    var tokenKeyToUse = tokenKey;
    var token = tokenKeyToUse ? getToken() : null;
    if (token) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    if (((_a = config.url) === null || _a === void 0 ? void 0 : _a.includes('http')) && !((_b = config.url) === null || _b === void 0 ? void 0 : _b.includes(globalBaseURL))) {
        return config;
    }
    if (appIdentifier && !((_c = config.headers) === null || _c === void 0 ? void 0 : _c['app-identifier'])) {
        config.headers['app-identifier'] = appIdentifier;
    }
    if (customerSecretKey && !((_d = config.headers) === null || _d === void 0 ? void 0 : _d['customer-secret-key'])) {
        config.headers['customer-secret-key'] = customerSecretKey;
    }
    return config;
});
axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            var keyStructure_1 = tokenKey.split('.');
            if (keyStructure_1.length === 2 &&
                (keyStructure_1[0].toLocaleLowerCase() === 'localstorage' ||
                    keyStructure_1[0].toLocaleLowerCase() === 'cookie')) {
                // Clear the token from local storage or cookie if it exists
                if (keyStructure_1[0].toLocaleLowerCase() === 'localstorage') {
                    if (localStorage.getItem(keyStructure_1[1])) {
                        localStorage.removeItem(keyStructure_1[1]);
                    }
                }
                else if (keyStructure_1[0].toLocaleLowerCase() === 'cookie') {
                    if (document.cookie
                        .split(';')
                        .some(function (item) { return item.trim().startsWith("".concat(keyStructure_1[1], "=")); })) {
                        document.cookie = "".concat(keyStructure_1[1], "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
                    }
                }
            }
        }
    }
    return Promise.reject(error);
});
export default axiosInstance;
